import React from 'react'
import { observer } from 'mobx-react-lite'
import { makeTextFieldIcon, TextFieldPlaceholder } from 'shared/ui/TextField'
import { Dropdown, Tooltip, Typography } from 'shared/ui'
import { useScheduleDateFiledContext } from 'pages/campaigns/ui/CampaignSchedule/ui/ScheduleDateFiled/context/sendLaterContext'
import styles from './styles.module.scss'
import { DateTimeDropdownContent } from './DateTimeDropdownContent'

export const DatetimeContent = observer(({ dropdownId }: { dropdownId: string }) => {
  const { isUseTimeFromField, uiDatetimeFieldTime, isMinutesOrHoursPeriod, when } =
    useScheduleDateFiledContext()

  const valueContent = (
    <Typography variant={'text-input-field-r'} ariaLabel={'time'}>
      {isUseTimeFromField ? 'Use the time from the field' : uiDatetimeFieldTime}
    </Typography>
  )

  if (isMinutesOrHoursPeriod || when === 'on') {
    return (
      <Tooltip label={'Time'} placement={'left'} fullWidth>
        <div>
          <TextFieldPlaceholder
            variant={'outline'}
            size={'small'}
            leftActions={[
              makeTextFieldIcon({
                icon: 'clock',
                className: styles.icon,
              }),
            ]}
            placeholder={valueContent}
          />
        </div>
      </Tooltip>
    )
  }

  return (
    <Dropdown
      width={330}
      parentsDropdownId={[dropdownId]}
      margin={0}
      customComponent={(onClose, dropdownId) => (
        <DateTimeDropdownContent dropdownId={dropdownId} onClose={onClose} />
      )}
      triggerComponent={() => (
        <Tooltip label={'Time'} placement={'left'} fullWidth>
          <div>
            <TextFieldPlaceholder
              effect={'collapse'}
              variant={'outline'}
              size={'small'}
              leftActions={[
                makeTextFieldIcon({
                  icon: 'clock',
                  className: styles.icon,
                }),
              ]}
              rightActions={[
                makeTextFieldIcon({
                  icon: 'chevronDown',
                  color: 'var(--content-neutral-primary)',
                }),
              ]}
              placeholder={valueContent}
            />
          </div>
        </Tooltip>
      )}
      PopperProps={{
        modifiers: [
          {
            name: 'offset',
            options: {
              // eslint-disable-next-line @typescript-eslint/ban-ts-comment
              // @ts-ignore
              offset: ({ reference }) => {
                return [0, -reference.height - 4]
              },
            },
          },
        ],
      }}
    />
  )
})
